import { createContext, useContext } from "react";
const SubmissionContext = createContext(null);
export function useSubmissionContext() {
    const ctx = useContext(SubmissionContext);
    if (!ctx) {
        return {};
    }
    return ctx;
}
export { SubmissionContext };
